<template>
  <BuiEntityListingPage
    entityItemsNamePlural="Roles"
    entityItemName="Role"
    areaAccessName="Administration"
    :ItemsLister="RolesLister"
    :createItemPage="true"
    @create="createRole()"
    :itemsListerBind="{ buiColumns: rolesColumns }"
  />
</template>

<script lang="ts" setup>
import BuiEntityListingPage from '@/components/bui/organisms/EntityListingPage';
import router from '@/router';
import RolesLister from './RolesLister/RolesLister.vue';
import rolesColumns from "./RolesLister/config/tableColumns.config";

function createRole() {
  router.push('roles/create');
}
</script>

<style lang="scss" scoped>
</style>
